/* eslint-disable import/no-cycle */
/* eslint-disable react/no-danger */
import React from 'react';
import IllnessJPG from '@assets/images/illness.jpg';
import IllnessMobileJPG from '@assets/images/illness-mobile.jpg';
import { ContainerSmall } from '~/utils/styles/utils';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';
import { useTranslationContext } from '~/pages/angststoerungen';
import { useTranslationContext as useTranslationContextEn } from '~/pages/en/anxiety-disorders';

const FearPage: React.FC = () => {
  const t = useTranslationContext();
  const tEn = useTranslationContextEn();

  return (
    <>
      <HeaderFooterLayout
        desktopHero={IllnessJPG}
        mobileHero={IllnessMobileJPG}
        altHero="Modell eines Gehirns zur Krankheitserklärung."
        enLink="/en/anxiety-disorders/"
        deLink="/angststoerungen/"
      >
        <ContainerSmall>
          <div
            dangerouslySetInnerHTML={{
              __html: t('FearContent1') || tEn('FearContent1'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('FearContent2') || tEn('FearContent2'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('FearContent3') || tEn('FearContent3'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('FearContent4') || tEn('FearContent4'),
            }}
          />
        </ContainerSmall>
      </HeaderFooterLayout>
    </>
  );
};

export default FearPage;
